/**
 * App Component
 *
 * Main app component with TanStack Router and Query integration
 * Integrates Better Auth session management
 */

import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { router } from './router';
import { useSessionCheck } from '@/shared/hooks/useSessionCheck';
import { useAuthStore } from '@/shared/stores/auth-store';
import { queryClient } from '@/shared/lib/query-client';

function AppContent() {
  // Initialize Better Auth session on app load
  const { isLoading } = useSessionCheck();
  const isSessionInitialized = useAuthStore((state) => state._sessionInitialized);

  // Bloquear renderização até sessão estar inicializada
  // Isso previne race condition onde router executa antes da sessão carregar
  if (isLoading || !isSessionInitialized) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  return <RouterProvider router={router} />;
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppContent />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
